import { Card } from "./cardSlice";
import { formatFullName } from "src/utils";
import { ApprovalNumber, cellClasses, DateStack, EmptyCell, MemberCell } from "src/components/UI/transactionCells";

const columns = [
  {
    title: "Card Proxy",
    dataIndex: "cardNumber",
    key: "cardNumber",
    render: (_text: string, card: Card) => {
      const proxy = card?.cardNumber || null;
      const holderName =
        card?.cardHolderName ||
        formatFullName(card?.first_name, card?.last_name) ||
        formatFullName(card?.user?.firstName, card?.user?.lastName);

      if (!proxy && !holderName) return <EmptyCell />;

      return (
        <div className={cellClasses.tableWallet}>
          {holderName && <span className={cellClasses.tableWalletName}>{holderName}</span>}
          {proxy ? (
            <ApprovalNumber value={proxy} />
          ) : (
            <span className={cellClasses.tableWalletDesc} style={{ fontStyle: "italic" }}>
              Card not issued
            </span>
          )}
        </div>
      );
    }
  },
  {
    title: "User",
    dataIndex: "id",
    key: "User",
    render: (_id: string, data: Card) => (
      <MemberCell
        fullName={formatFullName(data?.user?.firstName, data?.user?.lastName)}
        email={data?.user?.email}
        userId={data?.user?.id}
      />
    )
  },
  {
    // CPC: the date the card was added to the system — date only, no time.
    title: "Date Added",
    dataIndex: "created_at",
    key: "created_at",
    render: (created_at: string) => <DateStack value={created_at} dateOnly />
  }
];

export default columns;
